
var breadcrumbLess = {};
import genaration from '../../utils/classname';
export var breadcrumbClass = genaration(breadcrumbLess, 'breadcrumb');